import Vue from 'vue';
import VueRouter from 'vue-router';
import Buefy from 'buefy'
import Home from '../views/Home.vue';
import Account from '../views/Account.vue';
import Contact from '../views/Contact.vue';
import Pricing from '../views/Pricing.vue';
import Product from '../views/Product.vue';
import store from '../store';

Vue.use(VueRouter);
Vue.use(Buefy, { defaultIconPack: 'fas' });

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: Pricing,
  },
  {
    path: '/product',
    name: 'product',
    component: Product,
  },
  {
    path: '/signin',
    name: 'signin',
    // route level code-splitting
    // this generates a separate chunk (signin.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "signin" */ '../views/SignIn.vue'),
  },
  {
    path: '/signout',
    name: 'signout',
    beforeEnter: (to, from, next) => {
      store.dispatch('logout');
      next({ name: 'home' });
    },
  },
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/App.vue'),
    meta: {
      requiresAuth: true
    },
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.user.hasUser) {
      next({ name: 'signin' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth
  }
});

export default router;
